import React from 'react';
import CitizenProvider from "./context/citizen-context.jsx";
import CitizenForm from "./citizen-form.jsx";

const CitizenIndex = () => {
    return (
        <CitizenProvider>
            <CitizenForm />
        </CitizenProvider>
    );
};

export default CitizenIndex;